"use client"

import Link from "next/link"
import { useSession } from "@/contexts/SessionContext"
import { Button } from "@/components/atoms/Button/button"
import AvatarDropdown from "@/components/molecules/AvatarDropdown/avatar-dropdown"
import { HeaderTranslations } from "@/hooks/useTranslation"

interface TopHeaderClientProps {
  messages: HeaderTranslations
}

const TopHeaderClient = ({ messages }: TopHeaderClientProps) => {
  const { session, loading } = useSession()
  const user = session?.user

  if (loading) {
    return (
      <div className="h-10 w-10 animate-pulse rounded-full bg-gray-200 dark:bg-gray-700" />
    )
  }

  if (!user) {
    return (
      <>
        <Link href="/auth/login">
          <Button size="sm" variant="outline">{messages.login}</Button>
        </Link>
        <Link href="/auth/signup">
          <Button size="sm">{messages.signup}</Button>
        </Link>
      </>
    )
  }

  return <AvatarDropdown user={user} translations={messages} />
}

export default TopHeaderClient